import { useTheme } from "@/hooks/theme";
import { ThemedView, type DivProps } from "../ThemedView";

export const Card = (props: DivProps) => {
    const theme = useTheme();

    return (
        <ThemedView
            style={{
                background: theme.colors.surface,
                color: theme.colors.onSurface,
                padding: "22px",
                borderRadius: "22px",
                border: "solid 1px #e3e3e344",
                boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
            }}
        >
            {props.children}
        </ThemedView>
    );
};